import React from 'react'
import { CMSPath } from '../../../config/constant'
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { webLinkOpener } from '../../shared/linkOpener'
import {
  browserListPopup, currentWidget, popupOpenClose
} from '../../../action/action';
import {
  HashRouter,
  Link,
  Redirect
} from 'react-router-dom'
import defaultPromo from '../../../images/promos/promo-am.png'
import { heightFixer } from '../../../JS/heightFix'
import { playDoorCameraStream } from '../../../JS/playDoorCameraStream'

class promoWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPromoWidget: {},
      dataAvailable: true,
      promoWidgets: [],
      timeoutIn: false
    }
  }

  componentWillUnmount() {
    //console.log("we are unmounrtd");
    //timoutClear();
  }
  static getDerivedStateFromProps(props, state) {
    let timeO = false
    let currentPromo = state.currentPromoWidget
    let promoWidgets = state.promoWidgets
    //console.log("sddsv", props.promoWidgets.length)
    if (props.promoWidgets && props.promoWidgets.length > 0) {
      if (
        props.promoWidgets.length !== state.promoWidgets.length ||
        props.promoWidgets[0].btnImageUrl !== state.promoWidgets[0].btnImageUrl
      ) {
        //console.log("its true");
        timeO = true
        currentPromo = props.promoWidgets[0]
        promoWidgets = props.promoWidgets
      }
    }
    return {
      timeoutIn: timeO,
      currentPromoWidget: currentPromo,
      promoWidgets,
    }
  }

  getPromoWidget = (index) => {
    let timeoutInstance;
    this.setState({ currentPromoWidget: this.props.promoWidgets[index] });
    if (this.props.promoWidgets.length > index) {
      if (this.props.promoWidgets.length === index + 1) {
        timeoutInstance = setTimeout(
          () => { this.getPromoWidget(0) },
          parseInt(this.props.promoWidgets[index].totalDuration) * 1000
        );
      } else {
        timeoutInstance = setTimeout(
          () => { this.getPromoWidget(index + 1) },
          parseInt(this.props.promoWidgets[index].totalDuration) * 1000
        );
      }
    }


  }

  setDataAvilable = () => {
    this.setState({ dataAvailable: false, promoWidgets: this.props.promoWidgets });
    this.getPromoWidget(0);
  }


  onNavItemClick = (widget) => {
    this.props.currentWidget(widget);
    console.log("widget", widget);
    try {
      if (widget.widgetType === "App Launcher") {
        this.launcher(widget);
      }
      if (widget.widgetType === "URL Renderer") {
        console.log("url renderer", widget.targetUrl);
        window.open(widget.targetUrl);
      }
      if (widget.widgetType === "Hotel Guide") {
        console.log("Hotel Guide", `${CMSPath}${widget.targetUrl}`);
        if (widget.targetUrl) {
          if (window.cordova || window.device) {
            if (window.device.platform === "Android") {
              window.cordova.InAppBrowser.open(
                `${CMSPath}${widget.targetUrl}`,
                '_blank',
                'location=yes,hideurlbar=yes,closebuttoncaption=Back'
              );
            } else {
              window.cordova.InAppBrowser.open(
                `${CMSPath}${widget.targetUrl}`,
                '_blank',
                'location=no,closebuttoncaption=Back'
              );
            }
          } else {
            window.open(`${CMSPath}${widget.targetUrl}`);
          }
        }
      }
      if (widget.compName === "Door Camera") {
        console.log("called the door camera");
        if (this.props.streamingUrlFromConfig) {
          playDoorCameraStream(this.props.streamingUrlFromConfig, this.props);
        } else {
          console.log("URL is not there in client config.");
          this.props.popupOpenClose(true, "This functionality temporarily not available.");
        }
      }
    } catch (errorMsg) {
      console.log("error in on click", errorMsg);
    }
  }

  openLink = () => {
    let browserList;
    browserList = webLinkOpener(
      this.state.currentPromoWidget.targetUrl,
      this.state.currentPromoWidget.widgetType);
    if (browserList && browserList.length > 1) {
      this.props.browserListPopup(browserList, true);
    }
    // console.log("browserList", browserList)
  }

  loadDone = () => {
    heightFixer();
  }

  render() {
    let match = false
    //console.log("this.props.navList", this.props.navList);
    if (this.state.dataAvailable && (this.props.promoWidgets && this.props.promoWidgets.length > 0)) {
      this.setDataAvilable();
      // console.log("data avail")
    }
    return (
      <div
        id="usrPromo"
        className="widget col col-2 h-auto"
        style={{ height: "100%" }}>
        {
          this.props.navList.map((iterator) => {
            // console.log(this.state.currentPromoWidget.widgetType, "--", iterator.widgetType);
            if (this.state.currentPromoWidget.widgetType === iterator.widgetType) {
              // console.log("match found=", iterator.path);
              return (
                <HashRouter>
                  <Link exact to={iterator.path}
                    onClick={() => { this.onNavItemClick(this.state.currentPromoWidget) }}
                  >
                    {
                      this.state.currentPromoWidget.btnImageUrl ?
                        <img
                          src={`${CMSPath}${this.state.currentPromoWidget.btnImageUrl}`}
                          alt=""
                          onLoad={this.loadDone}
                        />
                        :
                        <img
                          // onClick={() => { this.onNavItemClick(this.state.currentPromoWidget) }}
                          src={require('../../../images/promos/promo_default.png')}
                          onLoad={this.loadDone}
                          alt="" />
                    }
                  </Link>
                </HashRouter>
              )
            } else if (!match && this.state.currentPromoWidget.widgetType === "URL Renderer") {
              match = true
              if (this.state.currentPromoWidget.btnImageUrl) {
                return (
                  <img
                    src={`${CMSPath}${this.state.currentPromoWidget.btnImageUrl}`}
                    alt=""
                    onLoad={this.loadDone}
                  />
                )
              }
              else {
                return (
                  <img
                    onClick={() => { this.onNavItemClick(this.state.currentPromoWidget) }}
                    src={require('../../../images/promos/promo_default.png')}
                    onLoad={this.loadDone}
                    alt="" />
                )
              }

            }
          })
        }

      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    //
    promoWidgets: state.store.home.currentDuration.bigWidgets ?
      state.store.home.currentDuration.bigWidgets.widgets : [],
    streamingUrlFromConfig: state.store.home.clientConfig.doorCameraFeed ?
      state.store.home.clientConfig.doorCameraFeed.doorCameraFeedUrl : null,
    navList: state.store.sideNavBar.navItems
  }
}

promoWidget.propTypes = {
  promoWidget: propTypes.object
}

export default connect(
  mapStateToProps,
  {
    browserListPopup,
    currentWidget,
    popupOpenClose
  }
)(promoWidget);